import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { useFormContext } from 'react-hook-form'

import { BlendIcon, FlashIcon, TriangleIcon } from '@/assets/icons'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { BookShelfForm } from '@/pages/customer/book-shelf'

export const ExtrasForm = () => {
	const form = useFormContext<BookShelfForm>()
	return (
		<div className="mt-10 lg:mt-12 flex flex-col">
			<h5 className="text-secondary/50 max-lg:text-xs font-medium">Wähle dein Paket</h5>
			<div className="flex mt-[25px] lg:mt-14 max-lg:flex-col items-start gap-6 lg:gap-8">
				<div
					onClick={() => form.setValue('extras', '1')}
					className={cn(
						'border cursor-pointer flex flex-col flex-1 justify-between gap-10 lg:gap-[13px] self-stretch group hover:bg-primary border-secondary/10 rounded-[16px] pt-5 pb-4 px-5',
						{ 'bg-primary': form.watch('extras') === '1' },
					)}>
					<div>
						<div
							className={cn(
								'pb-3 flex flex-col border-b border-secondary/10 group-hover:border-[#E0E4EB1A] gap-1',
								{ 'border-[#E0E4EB1A]': form.watch('extras') === '1' },
							)}>
							<div className="flex items-center gap-2">
								<BlendIcon
									className={cn('size-8 group-hover:text-white text-secondary', {
										'text-white': form.watch('extras') === '1',
									})}
								/>
								<h1
									className={cn('text-secondary group-hover:text-white font-extrabold text-xl', {
										'text-white': form.watch('extras') === '1',
									})}>
									Standard
								</h1>
							</div>
						</div>
						<h1
							className={cn(
								'mt-3 font-extrabold text-secondary group-hover:text-white text-[40px]',
								{ 'text-white': form.watch('extras') === '1' },
							)}>
							0
							<span
								className={cn('text-xl text-secondary/50 group-hover:text-white/75', {
									'text-white/75': form.watch('extras') === '1',
								})}>
								€
							</span>
						</h1>
						<div className="flex flex-col gap-4 mt-4">
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 shrink-0 text-secondary group-hover:text-white', {
										'text-white': form.watch('extras') === '1',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '1',
									})}>
									Du trägst deine Artikel ein
								</p>
							</div>
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 shrink-0 text-secondary group-hover:text-white', {
										'text-white': form.watch('extras') === '1',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '1',
									})}>
									Du etikettierst deine Artikel
								</p>
							</div>
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 text-secondary group-hover:text-white shrink-0', {
										'text-white': form.watch('extras') === '1',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '1',
									})}>
									Du füllst dein Regal mit deinen Artikeln bei Mietbeginn
								</p>
							</div>
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 text-secondary group-hover:text-white shrink-0', {
										'text-white': form.watch('extras') === '1',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '1',
									})}>
									Du räumst die nicht verkauften Artikel bei Mietende aus deinem Regal
								</p>
							</div>
						</div>
					</div>
					<Button
						variant="outline"
						className={cn(
							'rounded-lg group-hover:border-0 border-primary h-12 text-primary font-extrabold',
							{ 'border-0': form.watch('extras') === '1' },
						)}>
						Jetzt Buchen
					</Button>
				</div>
				<div
					onClick={() => form.setValue('extras', '2')}
					className={cn(
						'border cursor-pointer flex flex-col justify-between self-stretch gap-10 lg:gap-[13px] flex-1 group hover:bg-primary border-secondary/10 rounded-[16px] pt-5 pb-4 px-5',
						{ 'bg-primary': form.watch('extras') === '2' },
					)}>
					<div>
						<div
							className={cn(
								'pb-3 flex flex-col border-b border-secondary/10 group-hover:border-[#E0E4EB1A] gap-1',
								{ 'border-[#E0E4EB1A]': form.watch('extras') === '2' },
							)}>
							<div className="flex items-center gap-2">
								<FlashIcon
									className={cn('size-8 group-hover:text-white text-secondary', {
										'text-white': form.watch('extras') === '2',
									})}
								/>
								<h1
									className={cn('text-secondary group-hover:text-white font-extrabold text-xl', {
										'text-white': form.watch('extras') === '2',
									})}>
									Komfort
								</h1>
							</div>
						</div>
						<h1
							className={cn(
								'mt-3 font-extrabold text-secondary group-hover:text-white text-[40px]',
								{ 'text-white': form.watch('extras') === '2' },
							)}>
							25
							<span
								className={cn('text-xl text-secondary/50 group-hover:text-white/75', {
									'text-white/75': form.watch('extras') === '2',
								})}>
								€
							</span>
						</h1>
						<div className="flex flex-col gap-4 mt-4">
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 text-secondary group-hover:text-white shrink-0', {
										'text-white': form.watch('extras') === '2',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '2',
									})}>
									Du trägst deine Artikel ein
								</p>
							</div>
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 text-secondary group-hover:text-white shrink-0', {
										'text-white': form.watch('extras') === '2',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '2',
									})}>
									Du gibst deine Artikel bis spätestens 3 Werktage vor Mietbeginn bei uns im
									Geschäft ab
								</p>
							</div>
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 text-secondary group-hover:text-white shrink-0', {
										'text-white': form.watch('extras') === '2',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '2',
									})}>
									Wir etikettieren deine Artikel, präsentieren sie in deinem Regal und räumen diese
									bei Mietende wieder aus
								</p>
							</div>
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 text-secondary group-hover:text-white shrink-0', {
										'text-white': form.watch('extras') === '2',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '2',
									})}>
									Du holst deine nicht verkauften Artikel bis spätestens 3 Werktage nach Mietende
									wieder ab
								</p>
							</div>
						</div>
					</div>
					<Button
						variant="outline"
						className={cn(
							'rounded-lg group-hover:border-0 border-primary h-12 text-primary font-extrabold',
							{ 'border-0': form.watch('extras') === '2' },
						)}>
						Jetzt Buchen
					</Button>
				</div>
				<div
					onClick={() => form.setValue('extras', '3')}
					className={cn(
						'border cursor-pointer flex flex-col flex-1 self-stretch gap-10 lg:gap-[13px] group hover:bg-primary border-secondary/10 rounded-[16px] pt-5 pb-4 px-5',
						{ 'bg-primary': form.watch('extras') === '3' },
					)}>
					<div>
						<div
							className={cn(
								'pb-3 flex flex-col border-b border-secondary/10 group-hover:border-[#E0E4EB1A] gap-1',
								{ 'border-[#E0E4EB1A]': form.watch('extras') === '3' },
							)}>
							<div className="flex items-center gap-2">
								<TriangleIcon
									className={cn('size-8 group-hover:text-white text-secondary', {
										'text-white': form.watch('extras') === '3',
									})}
								/>
								<h1
									className={cn('text-secondary group-hover:text-white font-extrabold text-xl', {
										'text-white': form.watch('extras') === '3',
									})}>
									Sorglos
								</h1>
							</div>
						</div>
						<h1
							className={cn(
								'mt-3 font-extrabold text-secondary group-hover:text-white text-[40px]',
								{ 'text-white': form.watch('extras') === '3' },
							)}>
							30
							<span
								className={cn('text-xl text-secondary/50 group-hover:text-white/75', {
									'text-white/75': form.watch('extras') === '3',
								})}>
								€
							</span>
						</h1>
						<div className="flex flex-col gap-4 mt-4">
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 text-secondary group-hover:text-white shrink-0', {
										'text-white': form.watch('extras') === '3',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '3',
									})}>
									Du trägst deine Artikel ein
								</p>
							</div>
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 text-secondary group-hover:text-white shrink-0', {
										'text-white': form.watch('extras') === '3',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '3',
									})}>
									Du schickst deine Artikel per Post direkt zu uns in das Geschäft
								</p>
							</div>
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 text-secondary group-hover:text-white shrink-0', {
										'text-white': form.watch('extras') === '3',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '3',
									})}>
									Wir etikettieren deine Artikel, präsentieren sie in deinem Regal und räumen diese
									bei Mietende wieder aus
								</p>
							</div>
							<div className="flex items-start gap-1">
								<CheckCircleIcon
									className={cn('size-5 text-secondary group-hover:text-white shrink-0', {
										'text-white': form.watch('extras') === '3',
									})}
								/>
								<p
									className={cn('font-medium text-secondary/50 group-hover:text-white/75 text-xs', {
										'text-white/75': form.watch('extras') === '3',
									})}>
									Wir schicken dir deine nicht verkauften Artikel spätestens 7 Werktage nach
									Mietende an dich zurück
								</p>
							</div>
						</div>
					</div>
					<Button
						variant="outline"
						className={cn(
							'rounded-lg group-hover:border-0 border-primary h-12 text-primary font-extrabold',
							{ 'border-0': form.watch('extras') === '3' },
						)}>
						Jetzt Buchen
					</Button>
				</div>
			</div>
		</div>
	)
}
